"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTBPricingData = exports.RTBTrackData = exports.RTBTrackType = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
var RTBTrackType;
(function (RTBTrackType) {
    RTBTrackType[RTBTrackType["UNKNOWN_TRACK_TYPE"] = 0] = "UNKNOWN_TRACK_TYPE";
    RTBTrackType[RTBTrackType["IMPRESSION"] = 1] = "IMPRESSION";
    RTBTrackType[RTBTrackType["CLICK"] = 2] = "CLICK";
    RTBTrackType[RTBTrackType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RTBTrackType = exports.RTBTrackType || (exports.RTBTrackType = {}));
function createBaseRTBTrackData() {
    return { RTBTrackType: 0, RTBPricingData: undefined };
}
exports.RTBTrackData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.RTBTrackType !== 0) {
            writer.uint32(8).int32(message.RTBTrackType);
        }
        if (message.RTBPricingData !== undefined) {
            exports.RTBPricingData.encode(message.RTBPricingData, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRTBTrackData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.RTBTrackType = reader.int32();
                    break;
                case 2:
                    message.RTBPricingData = exports.RTBPricingData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseRTBTrackData();
        message.RTBTrackType = object.RTBTrackType ?? 0;
        message.RTBPricingData =
            object.RTBPricingData !== undefined && object.RTBPricingData !== null
                ? exports.RTBPricingData.fromPartial(object.RTBPricingData)
                : undefined;
        return message;
    },
};
function createBaseRTBPricingData() {
    return {
        bidMicroDollars: "0",
        finalBid: 0,
        runnerUpBid: 0,
        paidPrice: 0,
        internalFloor: 0,
        bidRequestFloor: 0,
        eventProb: 0,
        lambda: 0,
        gamma: 0,
        phi: 0,
        exchange: "",
    };
}
exports.RTBPricingData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bidMicroDollars !== "0") {
            writer.uint32(8).int64(message.bidMicroDollars);
        }
        if (message.finalBid !== 0) {
            writer.uint32(17).double(message.finalBid);
        }
        if (message.runnerUpBid !== 0) {
            writer.uint32(25).double(message.runnerUpBid);
        }
        if (message.paidPrice !== 0) {
            writer.uint32(33).double(message.paidPrice);
        }
        if (message.internalFloor !== 0) {
            writer.uint32(41).double(message.internalFloor);
        }
        if (message.bidRequestFloor !== 0) {
            writer.uint32(49).double(message.bidRequestFloor);
        }
        if (message.eventProb !== 0) {
            writer.uint32(57).double(message.eventProb);
        }
        if (message.lambda !== 0) {
            writer.uint32(65).double(message.lambda);
        }
        if (message.gamma !== 0) {
            writer.uint32(73).double(message.gamma);
        }
        if (message.phi !== 0) {
            writer.uint32(81).double(message.phi);
        }
        if (message.exchange !== "") {
            writer.uint32(90).string(message.exchange);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRTBPricingData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bidMicroDollars = longToString(reader.int64());
                    break;
                case 2:
                    message.finalBid = reader.double();
                    break;
                case 3:
                    message.runnerUpBid = reader.double();
                    break;
                case 4:
                    message.paidPrice = reader.double();
                    break;
                case 5:
                    message.internalFloor = reader.double();
                    break;
                case 6:
                    message.bidRequestFloor = reader.double();
                    break;
                case 7:
                    message.eventProb = reader.double();
                    break;
                case 8:
                    message.lambda = reader.double();
                    break;
                case 9:
                    message.gamma = reader.double();
                    break;
                case 10:
                    message.phi = reader.double();
                    break;
                case 11:
                    message.exchange = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseRTBPricingData();
        message.bidMicroDollars = object.bidMicroDollars ?? "0";
        message.finalBid = object.finalBid ?? 0;
        message.runnerUpBid = object.runnerUpBid ?? 0;
        message.paidPrice = object.paidPrice ?? 0;
        message.internalFloor = object.internalFloor ?? 0;
        message.bidRequestFloor = object.bidRequestFloor ?? 0;
        message.eventProb = object.eventProb ?? 0;
        message.lambda = object.lambda ?? 0;
        message.gamma = object.gamma ?? 0;
        message.phi = object.phi ?? 0;
        message.exchange = object.exchange ?? "";
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=rtb_track_data.js.map